import { render, staticRenderFns } from "./place-form-location.vue?vue&type=template&id=3b970368&"
import script from "./place-form-location.vue?vue&type=script&lang=js&"
export * from "./place-form-location.vue?vue&type=script&lang=js&"
import style0 from "./place-form-location.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QItem,QItemSection,QRadio,QItemLabel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QItem,QItemSection,QRadio,QItemLabel})
